import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const SearchCompanyRequest = withSuspense(lazy(() => import('./company-request-search')));
export default SearchCompanyRequest;
